 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        // Only react to significant changes, ignore attribute/style changes
        var hasSignificantChange = false
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
            hasSignificantChange = true
          }
        })
        
        if (!hasSignificantChange) return
        
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          // Don't update upsells when cart changes to prevent flickering
          // Upsells will only be updated when drawer is opened/closed
          
          // Only update wrapper positioning if needed
          insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          const oldWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
          const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
          
          if (oldWrapper && newWrapper) {
            // Compare content before updating to avoid unnecessary updates
            const oldContent = oldWrapper.innerHTML.trim()
            const newContent = newWrapper.innerHTML.trim()
            
            // Only update if content actually changed
            if (oldContent !== newContent) {
              // Smooth update: replace innerHTML instead of entire element to avoid flickering
              oldWrapper.innerHTML = newContent
              
              // Trigger custom event for slider reinitialization
              document.dispatchEvent(new CustomEvent('cart-upsell-updated'))
            }
            // If content didn't change, skip update to prevent flickering
          }

          insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
    
    // Update upsells only when drawer opens (not on every cart change to prevent flickering)
    function updateUpsellsOnDrawerOpen() {
      const drawer = document.querySelector('cart-drawer')
      if (!drawer) return
      
      let wasOpen = drawer.classList.contains('active')
      
      const drawerObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isOpen = drawer.classList.contains('active')
            
            // Only update when drawer transitions from closed to open
            if (isOpen && !wasOpen) {
              setTimeout(async () => {
                try {
                  const respoonse = await fetch(window.location.href)
                  const text = await respoonse.text()
                  const newDocument = new DOMParser().parseFromString(text, 'text/html')

                  const oldWrapper = document.querySelector('#cart-drawer-upsell-wrapper')
                  const newWrapper = newDocument.querySelector('#cart-drawer-upsell-wrapper')
                  
                  if (oldWrapper && newWrapper) {
                    const oldContent = oldWrapper.innerHTML.trim()
                    const newContent = newWrapper.innerHTML.trim()
                    
                    if (oldContent !== newContent) {
                      oldWrapper.innerHTML = newContent
                      document.dispatchEvent(new CustomEvent('cart-upsell-updated'))
                    }
                  }
                } catch (e) {
                  console.warn('Failed to update upsells:', e)
                }
              }, 300)
            }
            
            wasOpen = isOpen
          }
        })
      })
      
      drawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      })
    }
    
    // Initialize drawer open observer
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateUpsellsOnDrawerOpen)
    } else {
      updateUpsellsOnDrawerOpen()
    }
  })();